import {Grid, Typography, Button} from '@material-ui/core';
import {ArrowDropDown, ArrowDropUp} from '@material-ui/icons';
import {changeFooterContent} from 'Core/ducks/footer';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {FooterLink} from './FooterLink';
import './Footer.sass';

type FooterContentProps = {
  copyRightClass: boolean;
};

const FooterContent = (props: FooterContentProps) => {
  const dispatch = useDispatch();
  const {featureVariables} = useSelector((state: ReducerState) => state.featureToggle);
  const {footerContent} = useSelector((state: ReducerState) => state.footer);
  const checkFooterOpen =
    featureVariables['FOOTER_OPEN_DEFAULT'] !== undefined ? featureVariables.FOOTER_OPEN_DEFAULT : true;
  const [open, setOpen] = useState(checkFooterOpen);
  const handleFooterToggle = (e: any) => {
    setOpen(!open);
  };

  const copyRightClass = 'copyright_info';

  const topPanelStyles = open === true ? 'footer__top_open' : 'footer__top_closed';

  const copyRightYear = new Date().getFullYear();
  const renderFooterLinks = () => {
    switch (footerContent.key) {
      case 'ServerError':
      case 'Unauthorized':
      case 'Conflict':
      case 'NotFound':
        return (
          <Typography className={copyRightClass} variant="caption">
            {footerContent.message}
          </Typography>
        );
      case 'Loaded':
        return (
          <FooterLink
            contentMetaDataList={footerContent.Data.contentMetaDataList ? footerContent.Data.contentMetaDataList : []}
          ></FooterLink>
        );

      case 'Empty':
      case 'Loading':
      default:
        return (
          <Typography className={copyRightClass} variant="caption">
            Loading...
          </Typography>
        );
    }
  };

  useEffect(() => {
    dispatch(changeFooterContent(footerContent));
  }, []);

  useEffect(() => {
    setOpen(checkFooterOpen);
  }, [featureVariables]);

  return featureVariables !== undefined ? (
    <footer className="footer">
      <div className={`footer__top ${topPanelStyles}`}>
        <Grid container alignItems="center" spacing={1} className="footer__nav">
          {open === true && renderFooterLinks()}
          <div className={'footer__bottom'}>
            <p className={copyRightClass}></p>
            <div className="right-align-wrapper">
              <Button className={'footer__toggle'} onClick={handleFooterToggle}>
                FOOTER
                {open === true ? (
                  <ArrowDropDown className="arrow_icon_color" />
                ) : (
                  <ArrowDropUp className="arrow_icon_color" />
                )}
              </Button>
            </div>
          </div>
        </Grid>
      </div>
    </footer>
  ) : (
    <></>
  );
};

export default FooterContent;
